import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderPochtaCourierAddressDto } from './OrderPochtaCourierAddressDto'
import { OrderCdekDeliveryTimes } from './OrderCdekDeliveryTimes'
/**
* Class OrderDeliveryMethodPochtaCourierDto
*  Специфика доставки Почта России курьером (адрес до двери).
*/
export class OrderDeliveryMethodPochtaCourierDto extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'PochtaCourier' })
  readonly kind: string = 'PochtaCourier'


  /**
  * to
  * Адрес доставки до двери.  */
  @ActiveField({
    factory: [OrderPochtaCourierAddressDto, () => undefined]
  })
  to?: OrderPochtaCourierAddressDto


  /**
  * times
  * Сроки доставки (калькулятор + Extra*).  */
  @ActiveField({
    factory: [OrderCdekDeliveryTimes, () => undefined]
  })
  times?: null | OrderCdekDeliveryTimes


/**
  * barcode
  * ШПИ (штриховой почтовый идентификатор), ключ трекинга.
  */
  @ActiveField()
  barcode?: null | string
}
